import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicFieldDropdown, BasicInput } from "core/components";
import { ApplicationEditLayout, Content } from "core/layouts";

function TeamsEditTemplate({ teamsEditViewStore }) {
    const {
        contentLoading,
        form,
        userStore,
        userIdsArray,
        removeUserFromArray,
    } = teamsEditViewStore;

    return (
        <ApplicationEditLayout store={teamsEditViewStore}>
            <Content loading={contentLoading}>
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicInput field={form.$("name")} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--med"></div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <h3>Team Users</h3>
                                </div>

                                <div className="form__group col col-lrg-12 u-mar--bottom--sml teams-dropdown">
                                    <BaasicFieldDropdown
                                        field={form.$("userIds")}
                                        store={userStore}
                                    />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    {userIdsArray.map((user) => (
                                        <div
                                            className="btn btn--base btn--teams"
                                            key={user.id}
                                        >
                                            {user.displayName}
                                            <span
                                                title="Remove"
                                                className="u-icon u-icon--sml u-icon--closed--primary u-cursor--pointer"
                                                onClick={() =>
                                                    removeUserFromArray(user.id)
                                                }
                                            ></span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    );
}

TeamsEditTemplate.propTypes = {
    teamsEditViewStore: PropTypes.object,
    t: PropTypes.func,
};

export default defaultTemplate(TeamsEditTemplate);
